import { __ } from '@wordpress/i18n';
import deprecated from '@wordpress/deprecated';
export function warnIfCircularOptionPickerAsButtonsIsSet(componentName, asButtons) {
  if (asButtons === undefined) {
    return;
  }
  deprecated(`\`asButtons\` prop in wp.components.${componentName}`, {
    since: '7.2',
    alternative: '`presentation`',
    hint: '`asButtons={ true }` maps to `presentation="toggle-buttons"`. Explicit `presentation` takes precedence.'
  });
}
export function resolveCircularOptionPickerPresentation(presentation, asButtons) {
  return presentation ?? (asButtons ? 'toggle-buttons' : 'listbox');
}

/**
 * Computes the common props for the CircularOptionPicker.
 */
export function getComputeCircularOptionPickerCommonProps(asButtons, loop, ariaLabel, ariaLabelledby, presentation) {
  const resolvedPresentation = resolveCircularOptionPickerPresentation(presentation, asButtons);
  const metaProps = resolvedPresentation === 'listbox' ? {
    presentation: 'listbox',
    loop
  } : {
    presentation: resolvedPresentation
  };
  const labelProps = {
    'aria-labelledby': ariaLabelledby,
    'aria-label': ariaLabelledby ? undefined : ariaLabel || __('Custom color picker')
  };
  return {
    metaProps,
    labelProps,
    resolvedPresentation
  };
}